/**
 * ChampionPicker — a small, controlled select for choosing a champion
 * before creating or joining a match. Renders as a labeled dropdown; with a
 * single champion it still shows (so the selection is explicit) but there's
 * nothing else to pick yet.
 */

import type { ReactElement } from "react";
import type { ChampionId } from "@pit/protocol";
import { CHAMPIONS } from "./catalog.js";

export interface ChampionPickerProps {
  readonly value: ChampionId;
  readonly onChange: (id: ChampionId) => void;
  readonly disabled?: boolean;
}

export function ChampionPicker({
  value,
  onChange,
  disabled = false,
}: ChampionPickerProps): ReactElement {
  return (
    <label
      data-testid="champion-picker"
      style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14 }}
    >
      <span style={{ opacity: 0.75 }}>Champion</span>
      <select
        data-testid="champion-select"
        value={value}
        disabled={disabled}
        onChange={(e) => {
          onChange(e.target.value as ChampionId);
        }}
        style={{
          padding: "6px 10px",
          fontSize: 14,
          borderRadius: 4,
          border: "1px solid #3a4757",
          background: "#161c24",
          color: "#dfe6ef",
        }}
      >
        {CHAMPIONS.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
